/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * Status of the transaction
 */
export type TransactionStatus = typeof TransactionStatus[keyof typeof TransactionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionStatus = {
  pending: 'pending',
  posted: 'posted',
  void: 'void',
} as const;
